
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const CompanySuperAdminRoute = ({ children }) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  // While checking auth, show a loading state
  if (isLoading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-primary border-t-primary"></div>
    </div>;
  }

  // If not logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check if the user is a company super admin
  if (user.role !== 'company_super_admin') {
    // Redirect based on user role
    if (user.role === 'master_admin') {
      return <Navigate to="/master-admin" replace />;
    } else if (user.role === 'company_admin') {
      return <Navigate to="/admin" replace />;
    } else if (user.role === 'candidate') {
      return <Navigate to="/candidate" replace />;
    } else {
      return <Navigate to="/login" replace />;
    }
  }

  // If authenticated and role is company_super_admin, render children
  return children;
};

export default CompanySuperAdminRoute;
